import { render } from "./component-cwh.vue?vue&type=template&id=ea2016d8"
import script from "./component-cwh.vue?vue&type=script&lang=js"
export * from "./component-cwh.vue?vue&type=script&lang=js"

import "./component-cwh.vue?vue&type=style&index=0&id=ea2016d8&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__